import styled from "styled-components";

import dot from '@/images/vip-progress-dot.png'
import progressBg from '@/images/vip-progress.png'
import star from '@/images/vip-progress-star.png'

const View = styled.div`
  position: absolute;
  left: 3px;
  top: 666px;
  width: 100%;
  height: 340px;

  & > p {
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
    color: #fff;
  }

  & > .main {
    width: 912px;
    height: 250px;
    margin: 75px auto 0;
    position: relative;

    div.item {
      box-sizing: border-box;
      padding: 113px 0 0 0;
      width: 115px;
      height: 232px;
      text-align: center;
      position: relative;
      display: inline-block;
      margin-right: 84px;
      vertical-align: top;

      .award {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }

      div.button {
        position: absolute;
        bottom: -42px;
        left: 50%;
        transform: translateX(-50%);
      }

      &:nth-child(2) {
        margin-right: 84px;
      }

      &:nth-child(6) {
        margin-right: 0;
        float: right;
      }

      p {
        position: relative;
        z-index: 1;
      }

      p:nth-child(2) {
        font-size: 14px;
        color: #108fcf;
        margin-top: 12px;
      }

      p:nth-child(3) {
        font-size: 16px;
        color: #ffffff;
        margin-top: 16px;
      }

      div.star {
        position: absolute;
        left: 50%;
        top: 184px;
        width: 47px;
        height: 47px;
        transform: translateX(-50%);
        background-image: url("${dot}");

        &.active {
          top: 183px;
          width: 41px;
          height: 48px;
          background-image: url("${star}");
        }
      }
    }
  }
`;

const Progress = styled.div.attrs((props) => ({
  step: props.step
}))`
  width: ${props => [0, 55, 250, 450, 650, 830][props.step]}px;
  background-image: url("${progressBg}");
  background-repeat: repeat-x;
  height: 12px;
  border-radius: 6px;
  position: absolute;
  max-width: calc(100% - 8px);
  left: 7px;
  top: 201px;
`

export {
  View,
  Progress
}
